import useLoadEvent from './useLoadEvent';

export default useLoadEvent;
